import { CloseOutlined } from "@ant-design/icons";
import { Alert } from "antd";
import { Button, Checkbox, Input, List, Modal, Space } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { $t } from "~/i18n.js";
import { api } from "~/lib/api.js";


export const AuthoriseStudent = ({
  aanmeldingen = [],
  visible = false,
  onClose = () => {},
}) => {
  const [limitations, setLimitations] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const unauthorizedAanmeldingen = aanmeldingen.filter((a) => !a.authorised);

  const { club, vlieger_data } = useSelector((state) => state.persist);
  const defaultLimitations = club?.default_limitations || [];
  const dispatch = useDispatch();

  const fisInvalid = vlieger_data?.recency?.fis == 'invalid'

  useEffect(() => {
    if (visible) {
      setLimitations("");
      setSelectedIds(aanmeldingen?.length === 1 ? [aanmeldingen[0].id] : []);
    }
  }, [visible, aanmeldingen]);

  const handleAuthorize = async () => {
    if (selectedIds.length === 0) return;

    setLoading(true);
    try {
      const data = await api.post("aanmeldingen/authorise/", {
        aanmelding_ids: selectedIds,
        limitations: limitations,
      });

      if (data) {
        dispatch({
          type: "AANMELDING_SUCCESS",
          normalizeAsVliegers: false,
          default_vliegers: data.default_vliegers,
          dag_id: data.dag_id,
          ...data,
        });

        setLimitations("");
        setSelectedIds([]);
        onClose();
      }
    } catch (error) {
      console.error("Authorization failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const toggleSelection = (aanmeldingId) => {
    setSelectedIds((prev) =>
      prev.includes(aanmeldingId)
        ? prev.filter((id) => id !== aanmeldingId)
        : [...prev, aanmeldingId],
    );
  };

  const toggleSelectAll = () => {
    if (selectedIds.length === unauthorizedAanmeldingen.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(unauthorizedAanmeldingen.map((a) => a.id));
    }
  };

  const addLimitation = (limitation) => {
    if (!limitations) {
      setLimitations(limitation);
    } else {
      const needsPeriod = !limitations.trim().endsWith(".");
      setLimitations(limitations + (needsPeriod ? ". " : " ") + limitation);
    }
  };

  return (
    <Modal
      title={$t("Autoriseer Vliegers")}
      open={visible}
      onCancel={onClose}
      width={700}
      footer={[
        <Button
          key="authorize"
          type="primary"
          onClick={handleAuthorize}
          loading={loading}
          disabled={selectedIds.length === 0 || fisInvalid}
        >
          {$t("Autoriseer")} ({selectedIds.length})
        </Button>,
        <Button key="cancel" onClick={onClose}>
          {$t("Sluiten")}
        </Button>,
      ]}
    >

      {fisInvalid && (

        <Alert type="error" showIcon message={
          $t("Instructiebevoegheid is ongeldig. Authoriseren kan alleen als je zelf aan FIS-eisen voldoet.")
        }/>
      )}

      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        <Space direction="vertical" style={{ width: "100%" }}>
          <Space style={{ justifyContent: "space-between", width: "100%" }}>
            <strong className="label">{$t("Vliegers")}</strong>
            {unauthorizedAanmeldingen.length > 1 && (
              <Checkbox
                checked={selectedIds.length === unauthorizedAanmeldingen.length}
                indeterminate={
                  selectedIds.length > 0 &&
                  selectedIds.length < unauthorizedAanmeldingen.length
                }
                onChange={toggleSelectAll}
              >
                {$t("Selecteer alles")}
              </Checkbox>
            )}
          </Space>

          <List
            size="small"
            bordered
            dataSource={unauthorizedAanmeldingen}
            renderItem={(aanmelding) => (
              <List.Item>
                <Checkbox
                  checked={selectedIds.includes(aanmelding.id)}
                  onChange={() => toggleSelection(aanmelding.id)}
                >
                  {aanmelding.vlieger?.name}
                </Checkbox>
              </List.Item>
            )}
          />
        </Space>

        <div>
          <label>
            {$t("Beperkingen")} ({$t("Optioneel")}):
          </label>
          <Input.TextArea
            rows={3}
            value={limitations}
            onChange={(e) => setLimitations(e.target.value)}
            placeholder={$t("Bijv: Max wind 15kts, alleen lokaal, max 2 uur")}
            style={{ marginTop: 8 }}
          />
          <Space wrap size="small" style={{ marginTop: 8 }}>
            {defaultLimitations.map((limitation, index) => {
              const displayText =
                limitation.length > 30
                  ? limitation.substring(0, 27) + "..."
                  : limitation;
              return (
                <Button
                  key={index}
                  size="small"
                  onClick={() => addLimitation(limitation)}
                >
                  + "{displayText}"
                </Button>
              );
            })}
            <Button
              size="small"
              danger
              icon={<CloseOutlined />}
              onClick={() => setLimitations("")}
            >
              {$t("Wissen")}
            </Button>
          </Space>
        </div>
      </Space>
    </Modal>
  );
};
